// extracted by mini-css-extract-plugin
module.exports = {"Support":"ModuleTabs_Support__FfqYL"};